'use-strict';

import angular, { IHttpService } from 'angular';
import { ApiService } from '../../src/app/shared/services/api';
import { SupportTicketRequest } from '../../src/app/@shared-types/support';

export class SupportAPIService {
  private apiService: ApiService;

  constructor(
    $http: IHttpService,
    apiService: ApiService,
  ) {
    'ngInject';

    this.apiService = apiService;
  }

  public postSupportTicket = async (
    ticket: SupportTicketRequest,
  ): Promise<void> => this.apiService.post<void>('/api/support/ticket', ticket);
}

export default angular.module('services.supportApiService', [])
  .service('supportApiService', SupportAPIService)
  .name;
